/** 虚拟「全部」分组 ID（接口约定 -1） */
export const WATCHLIST_ALL_GROUP_ID = -1;

/** 自选分组层级：0 全部，1 一级分组，2+ 为标签 */
export const WATCHLIST_GROUP_LEVEL = Object.freeze({
  ALL: 0,
  LEVEL_1: 1,
  LEVEL_2: 2
});

/** 一级分组下个股查询范围：全部分组项 / 未分组项 */
export const WATCHLIST_ITEM_SCOPE = Object.freeze({
  ALL_GROUP_ITEMS: 1,
  UNGROUPED_ITEMS: 2
});

/** 市场筛选 tagId：1=A股 2=港股 3=美股 */
export const WATCHLIST_MARKET_TAG = Object.freeze({
  A_SHARE: '1',
  HK_SHARE: '2',
  US_SHARE: '3'
});

/** 市场筛选选项（label 为 i18n key） */
export const WATCHLIST_MARKET_OPTIONS = Object.freeze([
  { value: WATCHLIST_MARKET_TAG.A_SHARE, labelKey: 'common.noun.a_share' },
  { value: WATCHLIST_MARKET_TAG.HK_SHARE, labelKey: 'common.noun.h_share' },
  { value: WATCHLIST_MARKET_TAG.US_SHARE, labelKey: 'common.noun.us_share' }
]);

/** 自选左侧视图：自选列表 / 最近浏览 */
export const WATCHLIST_VIEW = Object.freeze({
  OPTIONAL: '1',
  RECENT: '2'
});

/** 自选列表拍平行类型：二级分组头 / 个股 */
export const WATCHLIST_LIST_ITEM_TYPE = Object.freeze({
  GROUP: 1,
  STOCK: 2
});

/** 分组项操作 action（POST /json/stock/item-action，文档 §6.2） */
export const WATCHLIST_ITEM_ACTION = Object.freeze({
  REMOVE_FROM_GROUP: 'REMOVE_FROM_GROUP',
  PIN_TOP: 'PIN_TOP',
  PIN_BOTTOM: 'PIN_BOTTOM'
});

/** 分组名称最大字符数 */
export const WATCHLIST_GROUP_NAME_MAX_LENGTH = 20;

/**
 * 是否为虚拟「全部」分组。
 * @param {number|string|null|undefined} groupId 分组 ID
 * @returns {boolean}
 */
export const isWatchlistAllGroup = (groupId) => Number(groupId) === WATCHLIST_ALL_GROUP_ID;
